export default {
  entity_short_name: "Dicree",
  baseurl_override: undefined,
  email: {
    generic: "capmart@dicree.com",
    doNotReply: "capmart@dicree.com",
    operations: "desmond.chew@dicree.com",
    cs: "desmond.chew@dicree.com",
    clientSuccess: "desmond.chew@dicree.com",
    settlements: {
      sg: "desmond.chew@dicree.com",
      my: "capmart@dicree.com",
    },
    onboarding: "desmond.chew@dicree.com",
    kyc: {
      my: "capmart@dicree.com",
    },
    compliance: "desmond.chew@dicree.com",
    internal: {
      legalAndCompliance: "desmond.chew@dicree.com",
      compliance: "desmond.chew@dicree.com",
      pcm: "desmond.chew@dicree.com",
    },
    trustee: "capmart@dicree.com",
  },
  entity_legal_url: "https://dicree.com/terms-of-use",
  entity_help_url: "https://help.alta.exchange/investor-resources",
  branding: {
    asset: {
      logoPublicUrl:
        "https://storage.googleapis.com/dealroom-tenant-dicree-pre-main/dicree.png",
    },
    fontSize: {
      "2xs": "0.625rem",
      xs: "0.75rem",
      sm: "0.875rem",
      base: "1rem",
      lg: "1.125rem",
      xl: "1.25rem",
      "2xl": "1.5rem",
      "3xl": "2rem",
      "4xl": "2.25rem",
    },
    colors: {
      brand: {
        primary: "#1c3490",
        "primary-hover": "#111f55",
        secondary: "#2d8795",
        "secondary-hover": "#17434d",
        accent: {
          1: "#ffab40",
          2: "#ffab40",
          3: "#ffab40",
          4: "#ffab40",
        },
        email: "#f3f4f6",
        "platform-background": "#1c3490",
      },
      white: "#ffffff",
      black: "#161618",
      gray: {
        50: "#f9fafb",
        100: "#f3f4f6",
        200: "#e5e7eb",
        300: "#d1d5db",
        400: "#9ca3af",
        500: "#6b7280",
        600: "#4b5563",
        700: "#374151",
        800: "#1f2937",
        900: "#111827",
      },
      forest: {
        50: "#fcfdfd",
        100: "#f5fbfc",
        200: "#daeaed",
        300: "#bdd4d9",
        400: "#90b3bb",
        500: "#2c5862",
        600: "#17434d",
        700: "#073a45",
        800: "#00313c",
        900: "#05262e",
      },
      red: {
        50: "#fffafa",
        100: "#fff0f1",
        200: "#f5d5d8",
        300: "#f5b5ba",
        400: "#f16974",
        600: "#af1623",
        800: "#681219",
        500: "#d93f4c",
        700: "#8c232c",
        900: "#570f15",
      },
      orange: {
        50: "#fffaf5",
        100: "#fff7ed",
        200: "#ffeedb",
        300: "#fed6a8",
        400: "#ffb057",
        500: "#f79a3e",
        600: "#ed8f1c",
        700: "#ad5918",
        800: "#703815",
        900: "#5e2f12",
      },
      green: {
        50: "#f8fcfb",
        100: "#edf8f4",
        200: "#d1e8df",
        300: "#aecfc2",
        400: "#5eae91",
        500: "#228f67",
        600: "#038153",
        700: "#186146",
        800: "#0b3b29",
        900: "#092f21",
      },
      blue: {
        50: "#eff6ff",
        100: "#dbeafe",
        200: "#bfdbfe",
        300: "#93c5fd",
        400: "#60a5fa",
        500: "#3b82f6",
        600: "#2563eb",
        700: "#1d4ed8",
        800: "#1e40af",
        900: "#1e3a8a",
      },
    },
  },

  allowViewOnlyInternalLogins: false,
  internalUserDomain: null,

  services: {
    platforms: ["SG"],
    "a-prime": {
      enabled: true,
      intercom: false,
      showOverlaysOnAPrimeAuthPage: false,
      integrations: {
        calendly: {
          enabled: false,
        },
        googleAds: {
          enabled: false,
        },
        googleAnalytics: {
          enabled: false,
        },
        googleTagManager: {
          enabled: false,
        },
        hubspot: {
          enabled: false,
        },
        linkedinInsights: {
          enabled: false,
        },
        recaptcha: {
          enabled: false,
        },
        segment: {
          enabled: false,
        },
        sentry: {
          enabled: false,
        },
        singpass: {
          enabled: false,
        },
      },
      disclaimer: {
        copy: `
RISK DISCLOSURE - SMALL OFFERS EXEMPTED OFFERS
The securities made available through this platform/facility are offered to you in reliance on the
exemption under section 272A(1) of the Securities and Futures Act (“SFA”). These offers are not
made in or accompanied by a prospectus that is registered by the Monetary Authority of Singapore
(the “Authority”). You should NOT invest in the securities offered unless you fully understand the risks and are
prepared to take the risks. You should carefully consider whether this investment is suitable for you
in light of your knowledge and experience in financial and business matters, investment objectives,
financial means and the risks that you are prepared to take. The risks of investing in such securities
include but are not limited to the following: 100% loss on such investments. There is a high risk that you may lose all your money on such investments. Investments available
through this platform/facility may include the shares or debt securities of early-stage companies or
companies without a proven track record. The risk of business failure is high. For every 10 new
businesses formed in Singapore, 7 to 8 would cease operations in the same year*. There is therefore
a high risk that you may lose 100% of your investment. Difficult to cash in or exit such investments. It may be difficult or even impossible for you to cash in on or exit such investments. Such
investments are subject to resale restrictions set out in section 272A(8) of the SFA, and there may
not be a secondary market for them. Risks of equities investments:
If such investments are in shares, you may not receive a dividend, and your shareholdings could be
significantly diluted if new shares are issued. In addition, if the shares are unpaid or partly paid, you
will still be liable to pay the remaining amount to the company. Online platform/facility failure. If the online platform/facility handles your money, you may also lose all your money in this
investment if the online platform/facility fails and becomes insolvent.
Risks of investing in foreign issuers. If such investments are offered by an issuer in a foreign jurisdiction, your investment will be subject
to the laws and regulations of that jurisdiction. You may also be subject to additional tax liabilities,
transaction costs and capital controls. No disclosure requirements. You may not have sufficient information to make fully informed investment decisions. There is no
statutory obligation for issuers or intermediaries to provide you with information that you would
reasonably require to make informed assessments of offers being made to you.
No assurance that financial statements from the companies that you invest in will be accurate or
accessible The financial statements of the companies which you invest in may not be subject to a statutory
audit. As such, the financial information presented to you may not have been ascertained by a qualified professional auditor. An unaudited financial statement may not accurately reflect the
financial health of a company. In addition, the financial statements of the companies may not be
made accessible to you in the absence of requirements in their home country for them to do so.
You should seek independent professional advice if you do not fully understand the risks of investing
in securities offered on this platform/facility or any of the statements above.

*Source: Singapore Department of Statistics, Formation & cessation of business entities in 2015,
http://www.singstat.gov.sg/`,
      },
      unitedStatesPersonDefinitionLink:
        "https://help.alta.exchange/what-is-a-united-states-person",
      politicallyExposedPersonDefinitionLink:
        "https://help.alta.exchange/what-does-a-politically-exposed-person-pep-mean",
      usPersonDefinitionLink:
        "https://help.alta.exchange/what-is-a-united-states-person",
      riskDisclosure: {
        link: "https://dicree.com/risk-disclosures",
      },
      features: {
        discordGiveaway0323: {
          enabled: true,
        },
        ecf: {
          enabled: false,
        },
        hackathon: {
          enabled: true,
        },
        hardcodeHamiltonHoldings: {
          enabled: true,
        },
        marketingOptIn: {
          enabled: false,
        },
        paymentRef: {
          enabled: true,
        },
        pricingGraph: {
          enabled: true,
        },
        primaryFirmDeal: {
          enabled: false,
        },
        topPicks: {
          enabled: false,
        },
        raiseCapital: {
          enabled: false,
          externalUrl: "https://fundraise.alta.exchange/",
        },
        portfolio: {
          enabled: false,
          orderStatusUrl: "https://help.alta.exchange/order-statuses-sg",
        },
        onboardingv4: {
          enabled: true,
        },
        mmf: {
          enabled: false,
          externalUrl: "#",
          yield: "X.XX%",
        },
        idenfy: {
          enabled: false,
        },
      },
    },
    atlas: {
      authentication: {
        provider: "credentials",
        superAdminEmails: [],
      },
      features: {
        superadmin: {
          enabled: true,
          modules: {
            beneficiaryOwner: false,
            singpass: false,
            topPicks: false,
            "finance.bankLedger": false,
            "finance.withdrawalApproval": false,
            "investor.cashBalance": false,
            "product.assets.listOnExchange": false,
            "product.deals.dealFee": false,
            "product.deals.investmentConfig": false,
            "product.deals.updateGraph": false,
            "product.deals.exchangeCode": false,
            mmf: false,
          },
          formOptions: {
            deals: {
              listingType: {
                omit: ["secondary"],
              },
              orderType: {
                omit: ["firm_order"],
              },
            },
            orders: {
              createType: {
                omit: ["issue"],
              },
            },
          },
        },
        idenfy: {
          enabled: false,
        },
      },
    },
  },

  paymentMethod: {
    displayPaymentMethod: true,
    sendPaymentMethodEmail: true,
    paymentMethodText: "Bank transfer or Paynow",
    paymentMethodLink: "https://help.alta.exchange/how-do-i-fund-my-account",
    primaryFirmPaymentInformation: {
      accountName: "AltaX Pte. Ltd.",
      uen: "201902743NTBA",
      accountNumber: "072-918536-0",
      bankName: "DBS Bank Ltd",
      bankCode: "7171",
      branchName: "Raffles Place",
      branchCode: "072",
      swiftCode: "DBSSSGSGXXX",
      paynowQRUrl:
        "https://storage.googleapis.com/dealroom-main/qr/paynow_08_2024.png",
    },
  },

  bankInformation: {
    sg: {
      accountName: "AltaX Pte. Ltd.",
      uen: "201902743NTBA",
      accountNumber: "072-918536-0",
      bankName: "DBS Bank Ltd",
      bankCode: "7171",
      branchName: "Raffles Place",
      branchCode: "072",
      swiftCode: "DBSSSGSGXXX",
      paynowQRUrl:
        "https://storage.googleapis.com/dealroom-main/qr/paynow_08_2024.png",
    },
    my: {
      beneficiaryName: "NA",
      beneficiaryAddress: "NA",
      bankName: "NA",
      bankBranch: "NA",
      swiftCode: "NA",
      accountType: "NA",
      accountNumber: "NA",
      bankCountryCity: "NA",
      bankAddress: "NA",
    },
  },
  custodySyncTncType: "sg-custody-tnc",
};
